<template>
  <div class="md:container md:mx-auto">
    <Head title="New Project" />
    <h1 class="mb-8 text-4xl font-bold">
      New Project
    </h1>
    <form class="md:flex" @submit.prevent="store">
      <!-- Project -->
      <div class="w-full md:w-2/5 p-2">
        <h2 class="pb-8 italic text-xl">Project</h2>

        <div class="flex flex-wrap mb-2 w-full">
          <text-input v-model="form.title" name="title" :error="form.errors.title" class="pb-8 pr-6 w-full max-w-sm" label="Project Title *" placeholder="Project Title" tabindex="1" required />
        </div>
        <div class="flex flex-wrap mb-2">
          <text-input v-model="form.address" name="address" :error="form.errors.address" class="pb-8 pr-6 w-full max-w-sm" label="Project Address" placeholder="Address" tabindex="2" />
        </div>
        <div class="flex flex-wrap mb-2">
          <text-input v-model="form.city" name="city" :error="form.errors.city" class="pb-8 pr-6 w-full max-w-sm" label="City" placeholder="City" tabindex="3" />
        </div>
        <div class="flex flex-wrap mb-2">
          <text-input v-model="form.state" name="state" :error="form.errors.state" class="pb-8 pr-6 w-full max-w-sm" label="State/Region" placeholder="State/Region" tabindex="4" />
        </div>
        <div class="flex flex-wrap mb-2">
          <text-input v-model="form.country" name="country" :error="form.errors.country" class="pb-8 pr-6 w-full max-w-sm" label="Country" placeholder="Select Country" tabindex="5" />
        </div>
        <div class="flex flex-wrap mb-2">
          <text-input v-model="form.zipcode" name="zipcode" :error="form.errors.zipcode" class="pb-8 pr-6 w-full max-w-sm" label="Zip/Post Code" placeholder="Zip/Post Code" tabindex="6" />
        </div>
        <div v-if="auth.user.is_admin" class="flex flex-wrap mb-2">
          <select-input v-model="form.price_list_id" :error="form.errors.price_list_id" class="pb-8 pr-6 w-full max-w-sm" label="Price List" tabindex="7">
            <option v-for="pl in pricelists" :key="pl.id" :value="pl.id"> {{ pl.name }}</option>
          </select-input>
        </div>
      </div>
      <!-- Customer -->
      <div class="w-full md:w-3/5 p-2 pt-10 md:pt-2 md:pl-24 border-t md:border-t-0 md:border-l border-gray">
        <h2 class="pb-8 italic text-xl">Customer</h2>

        <div class="flex flex-wrap mb-2">
          <text-input v-model="form.company" name="company" :error="form.errors.company" class="pb-8 pr-6 w-full max-w-sm" label="Company *" placeholder="Company name" tabindex="8" required />
        </div>
        <div class="flex flex-wrap mb-2">
          <text-input v-model="form.contact" name="contact" :error="form.errors.contact" class="pb-8 pr-6 w-full max-w-sm" label="Contact *" placeholder="contact name" tabindex="9" required />
        </div>
        <div class="flex flex-wrap mb-2">
          <text-input v-model="form.email" name="email" :error="form.errors.email" class="pb-8 pr-6 w-full max-w-sm" type="email" label="Email *" placeholder="Email Address" tabindex="10" required />
        </div>
        <div class="flex flex-wrap mb-2">
          <text-input v-model="form.phone" name="phone" :error="form.errors.phone" class="pb-8 pr-6 w-full max-w-sm" type="tel" mask="(###) ###-####" label="Phone" placeholder="Phone number" tabindex="11" />
        </div>
        <div class="flex flex-wrap mb-2">
          <text-input v-model="form.branch_location" name="branch_location" :error="form.errors.branch_location" class="pb-8 pr-6 w-full max-w-sm" label="Branch Location *" placeholder="Branch Location" tabindex="12" required />
        </div>
        <div class="flex flex-wrap mb-2">
          <text-input v-model="form.company_city" name="company_city" :error="form.errors.company_city" class="pb-8 pr-6 w-full max-w-sm" label="City" placeholder="Company City" tabindex="12" />
        </div>
        <div class="flex flex-wrap mb-2">
          <text-input v-model="form.company_state" name="company_state" :error="form.errors.company_state" class="pb-8 pr-6 w-full max-w-sm" label="State" placeholder="Company State" tabindex="13" />
        </div>
        <div class="w-full pr-6 lg:w-1/2">
          <loading-button :loading="form.processing" class="btn-blue float-right" type="submit">Create Project</loading-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    TextInput,
    SelectInput,
    LoadingButton,
  },
  layout: Layout,
  remember: 'form',
  props: {
    auth: Object,
    pricelists: Array,
    pricelist: Number,
  },
  data() {
    return {
      form: this.$inertia.form({
        title        : null,
        address      : null,
        city         : null,
        state        : null,
        country      : null,
        zipcode      : null,
        price_list_id: this.pricelist,
        company        : null,
        contact        : null,
        email          : null,
        phone          : null,
        branch_location: null,
        company_city   : null,
        company_state  : null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/projects')
    },
  },
}
</script>
